export const translations = {
  nl: {
    // Navbar
    nav: {
      services: "Diensten",
      hairpiece: "Haarwerk (Haarstuk)",
      products: "Producten",
      barbers: "Stylisten",
      gallery: "Gallerij",
      reviews: "Reviews",
      contact: "Contact & Locatie",
      adminPanel: "Kappers Paneel",
      bookNow: "Afspraak Maken",
      openStatus: "Nu Geopend",
      closedStatus: "Nu Gesloten",
      closingAt: "Sluit om 17:00",
      opensTomorrow: "Morgen open om 09:00",
      closedDays: "Zondag & Maandag Gesloten",
      myAccount: "Mijn Account",
      loginRegister: "Inloggen / Registreren",
      stampsLabel: "stempels"
    },
    // Hero
    hero: {
      badge: "Kapsalon, Barbershop & Haarwerk Rotterdam",
      title1: "Professionele Styling &",
      title2: "Haarwerk voor Mannen.",
      subtitle: "Gespecialiseerd in moderne herenkapsels, skin fades, baardverzorging én niet-chirurgische haarstukken van 100% echt haar aan het Samuel Esmeijerplein 3 in Rotterdam.",
      bookAppointment: "Direct Afspraak Maken",
      viewServices: "Bekijk Diensten & Prijzen",
      sterileKits: "100% Hygiënisch & Professioneel",
      noWaiting: "Geen Wachttijd op Afspraak",
      freeDrinks: "Gratis Koffie & Thee",
      idealAccepted: "PIN, iDEAL & Contant",
      experience: "Jaar Ervaring",
      happyClients: "Tevreden Klanten",
      googleRating: "Google Beoordeling",
      masterBarbers: "Ervaren Stylisten",
      salonLocation: "Samuel Esmeijerplein 3 • Rotterdam",
      salonTitle: "Aura Hair Hair & Grooming",
      googleReviewsText: "Google Reviews",
      premiumTag: "Premium Kwaliteit"
    },
    // Haarwerk
    hairpiece: {
      badge: "Niet-Chirurgische Haarvervanging",
      mainTitle: "Haarstuk voor mannen | Niet-chirurgische haarvervanging",
      subGoldTitle: "Gemaakt van 100% human hair & op maat gemaakte PU basis",
      description: "Haarstukken voor mannen van 100% echt menselijk haar en ultradunne PU basis. Elk haarwerk wordt semi-maatwerk geproduceerd en perfect aangesloten op uw eigen haar. Kies uw situatie hieronder en ontdek de mogelijkheden.",
      step1Badge: "STAP 1: SELECTEER UW HAARSITUATIE",
      step1Title: "Kies uw type haarverlies:",
      selectCard: "KIEZEN",
      selectedCard: "GESELECTEERD",
      recBadge: "Aanbevolen Oplossing voor:",
      humanHairFeature: "100% Echt Menselijk Haar",
      puBaseFeature: "Transparante PU Ademende Basis",
      bookFreeIntakeBtn: "GRATIS INTAKE INPLANNEN (€0)",
      sendPhotoWhatsApp: "Stuur Foto via WhatsApp",
      galleryBadge: "WAT KUNNEN WE VOOR U DOEN?",
      galleryTitle: "Voor & Na Resultaten bij Mannen",
      gallerySub: "Echte transformaties gerealiseerd bij Aura Hair met 100% natuurlijk resultaat.",
      trans1Title: "Kruin & Voorhoofdslijn Herstel",
      trans1Desc: "Binnen 90 minuten van dunner wordend haar naar een volle, natuurlijke haardos.",
      trans2Title: "Modern Skin Fade & Styling",
      trans2Desc: "Dynamische en jeugdige uitstraling met onzichtbare overloop naar de zijkanten.",
      trans3Title: "Vakkundige Plaatsing & Blending",
      trans3Desc: "Micro-skin basis sluit naadloos aan op de hoofdhuid voor maximale vrijheid.",
      guarantee1Title: "100% Human Hair",
      guarantee1Desc: "Natuurlijke glans, zachtheid en beweging. Niet van echt te onderscheiden.",
      guarantee2Title: "Ultradunne 0.03mm PU Huid",
      guarantee2Desc: "Onzichtbare overgang bij de voorste haarlijn en een ademende basis.",
      guarantee3Title: "Zwemmen, Sport & Douchen",
      guarantee3Desc: "Water- en zweetbestendige medische bevestiging voor dagelijks comfort.",
      guarantee4Title: "100% Natuurlijk & Onzichtbaar",
      guarantee4Desc: "Zelfs van dichtbij kijkt men direct op de natuurlijke hoofdhuid."
    },
    // Services
    services: {
      tag: "Diensten & Prijslijst",
      title1: "Onze Behandelingen &",
      title2: "Tarieven",
      subtitle: "Van strakke opscheer en klassiek knippen tot professionele haarwerken en baardverzorging.",
      all: "Alle Diensten",
      hair: "Haar & Knippen",
      beard: "Baard & Scheren",
      care: "Verzorging & Spa",
      vip: "Arrangementen",
      hairpieceCat: "Haarwerk & Haarstuk",
      minutes: "min",
      includes: "Inclusief:",
      addToBooking: "Kies & Maak Afspraak",
      popularTag: "Meest Gekozen",
      trendTag: "Trending",
      ritualTag: "Traditioneel",
      specialCareTag: "Speciale Verzorging",
      vipTag: "VIP Beleving",
      freeText: "Gratis"
    },
    // Gallery
    gallery: {
      tag: "Portfolio & Inspiratie",
      title1: "Stijl & Kapsels",
      title2: "Gallerij",
      subtitle: "Bekijk recente knipbeurten, fades en baardmodellen gecreëerd bij Aura Hair.",
      all: "Alle Modellen",
      fade: "Fade & Opscheren",
      classic: "Klassiek & Schaar",
      beard: "Baard & Lijnen",
      hairpiece: "Haarwerk Styling",
      viewBtn: "Vergroten",
      close: "Sluiten",
      barberLabel: "Stylist"
    },
    // Reviews
    reviews: {
      tag: "Klantervaringen",
      title1: "Wat Klanten",
      title2: "Over Ons Zeggen",
      subtitle: "Echte reviews van tevreden klanten uit Rotterdam en omgeving.",
      verifiedCustomer: "Geverifieerde Klant"
    },
    // Contact
    contact: {
      tag: "Bereikbaarheid & Openingstijden",
      title1: "Kom Langs in Onze",
      title2: "Salon in Rotterdam",
      subtitle: "Gelegen aan het Samuel Esmeijerplein 3 in Rotterdam. Gemakkelijk bereikbaar met auto en openbaar vervoer.",
      phoneTitle: "Telefonisch Contact",
      whatsappTitle: "WhatsApp Afspraak & Advies",
      addressTitle: "Adres & Locatie",
      workingHoursTitle: "Openingstijden",
      callNow: "Bel Direct",
      whatsappChat: "Stuur WhatsApp Bericht",
      openInGoogleMaps: "Open in Google Maps",
      getDirections: "Route Beschrijven",
      paymentMethodsTitle: "Geaccepteerde Betaalmethoden",
      open7Days: "Dinsdag t/m Zaterdag Geopend (09:00 - 17:00)",
      walkInNote: "Zonder afspraak binnenlopen is mogelijk op basis van beschikbaarheid.",
      ctaTitle: "Tijd voor een Frisse Look?",
      ctaSubtitle: "Boek in minder dan 1 minuut uw stoel bij Aura Hair.",
      directNav: "Directe Navigatie",
      rotterdamDistrict: "3067 HP Rotterdam (Prins Alexander / Het Lage Land)",
      copyAddress: "Adres Kopiëren",
      copied: "Gekopieerd!",
      openInApp: "Openen in Navigatie-app",
      closedText: "Gesloten"
    },
    // Booking
    booking: {
      title: "Online Afspraak Maken",
      subtitle: "Kies uw gewenste behandeling, datum en tijdstip.",
      step1: "1. Behandeling",
      step2: "2. Datum & Tijd",
      step3: "3. Uw Gegevens",
      step4: "4. Bevestiging",
      servicesHeading: "Kies één of meerdere behandelingen",
      servicesSub: "Combineer knippen, baardverzorging of haarwerk naar keuze.",
      dateHeading: "Selecteer een Datum",
      timeHeading: "Selecteer een Tijdstip",
      hoursNotice: "Di - Za: 09:00 - 17:00 (Zo & Ma Gesloten)",
      contactHeading: "Uw Contactgegevens",
      contactSub: "Vul uw gegevens in voor de afspraakbevestiging.",
      fullName: "Volledige Naam",
      fullNamePlaceholder: "bijv. Daan van Dijk",
      phone: "Telefoonnummer",
      phonePlaceholder: "bijv. +31 6 12345678",
      email: "E-mailadres (Optioneel)",
      emailPlaceholder: "bijv. daan@example.nl",
      notes: "Opmerkingen of speciale wensen (Optioneel)",
      notesPlaceholder: "bijv. Extra strakke fade, baardolie gewenst...",
      summaryServices: "behandeling(en)",
      totalPrice: "Totaal:",
      next: "Volgende Stap",
      back: "Terug",
      confirmBooking: "Afspraak Bevestigen",
      successTitle: "Uw Afspraak is Succesvol Bevestigd!",
      successSub: "We kijken ernaar uit u te verwelkomen bij Aura Hair aan het Samuel Esmeijerplein 3 in Rotterdam.",
      bookingCode: "Afspraakcode",
      status: "Status",
      confirmedStatus: "Bevestigd",
      client: "Klant:",
      masterBarber: "Salon:",
      dateTime: "Datum & Tijd:",
      estDuration: "Geschatte Duur:",
      selectedServices: "Gekozen Behandelingen:",
      whatsappNotify: "WhatsApp Bevestiging Sturen",
      close: "Sluiten",
      today: "Vandaag",
      tomorrow: "Morgen",
      nameRequired: "Vul alstublieft uw naam in.",
      phoneRequired: "Vul een geldig telefoonnummer in.",
      loyaltyDiscountPill: "🎁 10e Afspraak Beloning: 1 Gratis Knipbeurt Toegepast!",
      specialDiscountPill: "🎉 Speciale Dagen Korting Actief!",
      applySpecialDiscount: "Korting Toepassen",
      specialDayActive: "Speciale Campagne:",
      regularPrice: "Normale Prijs:",
      discountedPrice: "VIP Ledenprijs:"
    },
    // Auth & Loyalty System
    auth: {
      loginTab: "Inloggen",
      registerTab: "Nieuw Account",
      loginTitle: "Welkom Terug",
      loginSub: "Log in om uw afspraken en spaarkaart te bekijken.",
      registerTitle: "Account Aanmaken",
      registerSub: "Exclusief voor geregistreerde klanten: spaar voor 1 gratis knipbeurt bij elke 10e afspraak!",
      identifierLabel: "Telefoonnummer of E-mail",
      identifierPlaceholder: "+31 6 ... of naam@email.nl",
      nameLabel: "Uw Volledige Naam",
      namePlaceholder: "bijv. Daan van Dijk",
      phoneLabel: "Telefoonnummer",
      phonePlaceholder: "+31 6 12 34 56 78",
      emailLabel: "E-mailadres (Optioneel)",
      emailPlaceholder: "daan@example.nl",
      passwordLabel: "Wachtwoord / Pincode",
      passwordPlaceholder: "Voer uw wachtwoord of 4-cijferige pincode in",
      loginBtn: "Inloggen",
      registerBtn: "Account Aanmaken & Opslaan",
      noAccount: "Nog geen account?",
      haveAccount: "Al een account?",
      loginSuccess: "Succesvol ingelogd!",
      registerSuccess: "Account succesvol aangemaakt!",
      userNotFound: "Geen account gevonden met deze gegevens.",
      wrongPassword: "Het wachtwoord is onjuist.",
      alreadyExists: "Er bestaat al een account met dit nummer of e-mailadres.",
      orSocial: "Of ga direct verder met",
      googleBtn: "Google / Google Play",
      facebookBtn: "Facebook",
      socialConnecting: "Verbinden...",
      socialSuccess: "Succesvol ingelogd!"
    },
    loyalty: {
      cardTitle: "Aura Hair Digitale Spaarkaart",
      cardSub: "Spaar 10 stempels en ontvang 1 gratis knipbeurt cadeau!",
      stampsProgress: "Stempels Verzameld",
      remainingText: "Nog {n} afspraak/afspraken tot uw gratis knipbeurt!",
      eligibleText: "🎉 Gefeliciteerd! Uw volgende afspraak is de 10e en is een GRATIS knipbeurt!",
      totalVisits: "Totaal Bezoeken:",
      rewardsClaimed: "Gratis Beurten Ontvangen:",
      stampTooltip: "Stempel {n}/10"
    },
    profile: {
      title: "Mijn Profiel & Afspraken",
      subtitle: "Beheer uw bezoeken, bekijk uw spaarkaart en plan snel opnieuw.",
      myBookings: "Mijn Afspraken",
      upcoming: "Aankomend",
      past: "Afgerond",
      noBookings: "U heeft nog geen afspraken geboekt.",
      bookFirstBtn: "Eerste Afspraak Plannen",
      logout: "Uitloggen",
      cancelBooking: "Annuleren",
      rebook: "Opnieuw Boeken"
    },
    // Admin Panel
    admin: {
      title: "Aura Hair Beheer & Afspraken Paneel",
      badge: "Eigenaar / Beheerder",
      subtitle: "Afsprakenoverzicht, status bijwerken en omzetstatistieken",
      refresh: "Vernieuwen",
      totalRecords: "Totaal Afspraken",
      activePending: "Actief / Bevestigd",
      completed: "Voltooid",
      estRevenue: "Geschatte Omzet",
      allStatus: "Alle Statussen",
      searchPlaceholder: "Zoek op klantnaam, telefoon of code...",
      noResults: "Geen afspraken gevonden",
      markConfirmed: "Bevestigen",
      markCompleted: "Voltooid",
      markCancelled: "Annuleren",
      delete: "Verwijderen",
      whatsappCustomer: "WhatsApp Klant",
      protectedTitle: "Beveiligde Toegang",
      enterPinPrompt: "Voer de 6-cijferige pincode van Aura Hair in om toegang te krijgen.",
      pinPlaceholder: "Pincode (••••••)",
      pinErrorText: "Onjuiste pincode! Probeer opnieuw.",
      loginBtn: "Inloggen",
      logoutBtn: "Uitloggen",
      thCode: "Afspraak / Code",
      thClient: "Klant Details",
      thService: "Behandeling",
      thDateTime: "Datum & Tijd",
      thTotal: "Totaal",
      thStatus: "Status",
      thActions: "Acties",
      tabAppointments: "Afspraken",
      tabCustomers: "Klanten & Spaarkaart",
      tabReports: "Dagrapporten & Kassa",
      tabReset: "Systeem Reset",
      registeredClients: "Geregistreerde Klanten",
      rewardReadyBadge: "Beloning Klaar",
      searchCustomerPlaceholder: "Zoek op klantnaam, telefoon of e-mail...",
      customersCount: "{n} Klanten Geregistreerd",
      thCustomer: "Klant",
      thContact: "Contact",
      thTotalVisits: "Totaal Bezoeken",
      thStampCard: "Spaarkaart (0-10)",
      thRewardStatus: "Korting Status",
      thTotalSpend: "Totaal Omzet",
      thAdjustStamps: "Stempels",
      noCustomersFound: "Nog geen geregistreerde klanten gevonden.",
      visitsUnit: "Afspraken",
      lastVisitLabel: "Laatste:",
      registeredLabel: "Geregistreerd:",
      rewardReadyText: "🎉 1 Gratis Knipbeurt Klaar!",
      remainingVisitsText: "Nog {n} afspraken",
      addStampTitle: "1 Stempel Toevoegen",
      removeStampTitle: "1 Stempel Verwijderen",
      sendWhatsAppTitle: "WhatsApp Bericht Sturen",
      msgRewardReady: "Hallo {name}, bij Aura Hair Rotterdam heeft u uw 10e stempel verzameld! Uw 1 gratis knipbeurt staat klaar voor uw volgende afspraak. Graag tot snel aan het Samuel Esmeijerplein 3!",
      msgStampProgress: "Hallo {name}, uw actuele spaarkaart bij Aura Hair Rotterdam: {stamps}/10 stempels. Nog {remaining} afspraak/afspraken tot uw gratis knipbeurt!"
    },
    // Music Player
    music: {
      title: "Aura Hair Lounge Muziek",
      nowPlaying: "Nu aan het spelen",
      paused: "Gepauzeerd (Klik om te starten)",
      volume: "Volume",
      openYoutube: "Bekijk op YouTube"
    },
    // Footer
    footer: {
      quickLinks: "Snelle Links",
      popularServices: "Populaire Diensten",
      onlineBooking: "Online Boeken",
      bookFast: "Geen wachttijd, boek uw stoel online in 1 minuut.",
      adminLogin: "Aura Hair Beheer Login",
      allRights: "Alle rechten voorbehouden.",
      paymentMethods: "Geaccepteerde Betaalmethoden: PIN, iDEAL, Apple Pay, Contant"
    }
  },

  en: {
    nav: {
      services: "Services",
      hairpiece: "Hair Systems",
      products: "Products",
      barbers: "Stylists",
      gallery: "Gallery",
      reviews: "Reviews",
      contact: "Contact & Location",
      adminPanel: "Admin Panel",
      bookNow: "Book Now",
      openStatus: "Open Now",
      closedStatus: "Closed Now",
      closingAt: "Closes at 17:00",
      opensTomorrow: "Opens tomorrow at 09:00",
      closedDays: "Closed on Sunday & Monday",
      myAccount: "My Account",
      loginRegister: "Log In / Register",
      stampsLabel: "stamps"
    },
    hero: {
      badge: "Barbershop & Hair System Studio Rotterdam",
      title1: "Master Styling &",
      title2: "Custom Hair Systems.",
      subtitle: "Specializing in sharp precision haircuts, skin fades, beard sculpting, and non-surgical 100% human hair systems at Samuel Esmeijerplein 3, Rotterdam.",
      bookAppointment: "Book Appointment Online",
      viewServices: "View Services & Pricing",
      sterileKits: "100% Sterile & Professional",
      noWaiting: "Zero Waiting on Appointment",
      freeDrinks: "Complimentary Coffee & Tea",
      idealAccepted: "PIN, iDEAL & Cash Accepted",
      experience: "Years of Mastery",
      happyClients: "Satisfied Clients",
      googleRating: "Google Rating",
      masterBarbers: "Expert Stylists",
      salonLocation: "Samuel Esmeijerplein 3 • Rotterdam",
      salonTitle: "Aura Hair Hair & Grooming",
      googleReviewsText: "Google Reviews",
      premiumTag: "Premium Quality"
    },
    hairpiece: {
      badge: "Non-Surgical Hair Replacement",
      mainTitle: "Men's Hair Systems | Non-surgical hair restoration",
      subGoldTitle: "Crafted with 100% natural human hair on custom PU skin base",
      description: "Men's custom hair systems engineered with 100% natural human hair and ultra-thin PU bases. Undetectable transitions and water-resistant medical bonding. Select your hair situation below.",
      step1Badge: "STEP 1: SELECT YOUR HAIR SITUATION",
      step1Title: "Choose your hair loss pattern:",
      selectCard: "SELECT",
      selectedCard: "SELECTED",
      recBadge: "Recommended Solution for:",
      humanHairFeature: "100% Natural Human Hair",
      puBaseFeature: "Transparent Breathable PU Base",
      bookFreeIntakeBtn: "BOOK FREE CONSULTATION (€0)",
      sendPhotoWhatsApp: "Send Photo via WhatsApp",
      galleryBadge: "WHAT WE CAN DO FOR YOU",
      galleryTitle: "Before & After Client Transformations",
      gallerySub: "Real transformations performed at Aura Hair with 100% undetectable results.",
      trans1Title: "Crown & Hairline Restoration",
      trans1Desc: "From thinning hair to a full, natural look in just 90 minutes.",
      trans2Title: "Modern Skin Fade & Textured Cut",
      trans2Desc: "Sharp and youthful styling with seamless blending into natural sides.",
      trans3Title: "Precision Cut-in & Custom Fit",
      trans3Desc: "Micro-skin base bonds seamlessly to the scalp for maximum freedom.",
      guarantee1Title: "100% Human Hair",
      guarantee1Desc: "Natural shine, softness, and flowing movement. Indistinguishable from real hair.",
      guarantee2Title: "Ultra-Thin 0.03mm PU Skin",
      guarantee2Desc: "Undetectable front hairline transition with breathable micro-skin base.",
      guarantee3Title: "Swimming, Sports & Showering",
      guarantee3Desc: "Water and sweat resistant medical-grade bonding for everyday confidence.",
      guarantee4Title: "100% Natural & Undetectable",
      guarantee4Desc: "Even upon close inspection, it looks entirely natural like growing from the scalp."
    },
    services: {
      tag: "Services & Price List",
      title1: "Our Treatments &",
      title2: "Pricelist",
      subtitle: "From crisp skin fades and scissor styling to custom hair systems and beard sculpting.",
      all: "All Services",
      hair: "Hair & Styling",
      beard: "Beard & Shave",
      care: "Care & Spa",
      vip: "VIP Packages",
      hairpieceCat: "Hair Systems",
      minutes: "min",
      includes: "Includes:",
      addToBooking: "Select & Book",
      popularTag: "Most Popular",
      trendTag: "Trending",
      ritualTag: "Classic Ritual",
      specialCareTag: "Special Care",
      vipTag: "VIP Experience",
      freeText: "Free"
    },
    gallery: {
      tag: "Portfolio & Inspiration",
      title1: "Style & Cuts",
      title2: "Gallery",
      subtitle: "Browse recent haircuts, skin fades, and beard styles created at Aura Hair.",
      all: "All Styles",
      fade: "Fade & Taper",
      classic: "Classic & Scissor",
      beard: "Beard Design",
      hairpiece: "Hair Systems",
      viewBtn: "View Image",
      close: "Close",
      barberLabel: "Stylist"
    },
    reviews: {
      tag: "Customer Reviews",
      title1: "What Our Clients",
      title2: "Say About Us",
      subtitle: "Real 5-star Google reviews from satisfied gentlemen across Rotterdam.",
      verifiedCustomer: "Verified Client"
    },
    contact: {
      tag: "Location & Opening Hours",
      title1: "Visit Our Salon in",
      title2: "Rotterdam East",
      subtitle: "Located at Samuel Esmeijerplein 3, Rotterdam. Easily accessible by car with ample parking and public transport.",
      phoneTitle: "Phone Inquiries",
      whatsappTitle: "WhatsApp Booking & Advice",
      addressTitle: "Salon Address",
      workingHoursTitle: "Opening Hours",
      callNow: "Call Now",
      whatsappChat: "Chat on WhatsApp",
      openInGoogleMaps: "Open in Google Maps",
      getDirections: "Get Directions",
      paymentMethodsTitle: "Accepted Payment Methods",
      open7Days: "Tuesday to Saturday Open (09:00 - 17:00)",
      walkInNote: "Walk-ins are welcomed based on daily chair availability.",
      ctaTitle: "Ready for a Sharp New Look?",
      ctaSubtitle: "Book your appointment in under 1 minute at Aura Hair.",
      directNav: "Turn-by-Turn GPS",
      rotterdamDistrict: "3067 HP Rotterdam (Prins Alexander / Het Lage Land)",
      copyAddress: "Copy Address",
      copied: "Copied!",
      openInApp: "Open in Navigation App",
      closedText: "Closed"
    },
    booking: {
      title: "Online Booking System",
      subtitle: "Select your desired treatment, preferred date and time.",
      step1: "1. Service",
      step2: "2. Date & Time",
      step3: "3. Customer Details",
      step4: "4. Confirmation",
      servicesHeading: "Choose One or Multiple Services",
      servicesSub: "Combine haircuts, beard styling or hair systems as needed.",
      dateHeading: "Select Date",
      timeHeading: "Select Time",
      hoursNotice: "Tue - Sat: 09:00 - 17:00 (Sun & Mon Closed)",
      contactHeading: "Your Contact Information",
      contactSub: "Enter your contact details to receive instant confirmation.",
      fullName: "Full Name",
      fullNamePlaceholder: "e.g. Daan van Dijk",
      phone: "Phone Number",
      phonePlaceholder: "e.g. +31 6 12345678",
      email: "Email Address (Optional)",
      emailPlaceholder: "e.g. daan@example.com",
      notes: "Notes or Special Requests (Optional)",
      notesPlaceholder: "e.g. Skin fade on the sides, beard oil...",
      summaryServices: "service(s)",
      totalPrice: "Total:",
      next: "Next Step",
      back: "Back",
      confirmBooking: "Confirm Booking",
      successTitle: "Your Appointment is Confirmed!",
      successSub: "We look forward to welcoming you at Aura Hair, Samuel Esmeijerplein 3, Rotterdam.",
      bookingCode: "Booking Code",
      status: "Status",
      confirmedStatus: "Confirmed",
      client: "Client:",
      masterBarber: "Salon:",
      dateTime: "Date & Time:",
      estDuration: "Est. Duration:",
      selectedServices: "Selected Services:",
      whatsappNotify: "Send WhatsApp Confirmation",
      close: "Close",
      today: "Today",
      tomorrow: "Tomorrow",
      nameRequired: "Please enter your name.",
      phoneRequired: "Please enter a valid phone number.",
      loyaltyDiscountPill: "🎁 10th Booking Loyalty Reward: 1 Free Haircut Applied!",
      specialDiscountPill: "🎉 Special Day Discount Active!",
      applySpecialDiscount: "Apply Discount",
      specialDayActive: "Special Campaign:",
      regularPrice: "Regular Price:",
      discountedPrice: "VIP Member Price:"
    },
    auth: {
      loginTab: "Log In",
      registerTab: "New Account",
      loginTitle: "Welcome Back",
      loginSub: "Log in to manage appointments and loyalty rewards.",
      registerTitle: "Create Account",
      registerSub: "Exclusive for registered customers: earn 1 free haircut on every 10th booking!",
      identifierLabel: "Phone Number or Email",
      identifierPlaceholder: "+31 6 ... or name@email.com",
      nameLabel: "Your Full Name",
      namePlaceholder: "e.g. Daan van Dijk",
      phoneLabel: "Phone Number",
      phonePlaceholder: "+31 6 12 34 56 78",
      emailLabel: "Email Address (Optional)",
      emailPlaceholder: "daan@example.com",
      passwordLabel: "Password / PIN",
      passwordPlaceholder: "Enter your password or 4-digit PIN",
      loginBtn: "Log In",
      registerBtn: "Create Account & Save",
      noAccount: "Don't have an account?",
      haveAccount: "Already registered?",
      loginSuccess: "Successfully logged in!",
      registerSuccess: "Account created successfully!",
      userNotFound: "No account found with these details.",
      wrongPassword: "Incorrect password entered.",
      alreadyExists: "An account already exists with this phone or email.",
      orSocial: "Or continue with",
      googleBtn: "Google / Google Play",
      facebookBtn: "Facebook",
      socialConnecting: "Connecting...",
      socialSuccess: "Logged in successfully!"
    },
    loyalty: {
      cardTitle: "Aura Hair Digital Loyalty Card",
      cardSub: "Collect 10 stamps and receive 1 free haircut as a reward!",
      stampsProgress: "Stamps Collected",
      remainingText: "{n} booking(s) away from your free haircut!",
      eligibleText: "🎉 Congratulations! Your next booking is your 10th and qualifies for a FREE haircut!",
      totalVisits: "Total Visits:",
      rewardsClaimed: "Free Haircuts Claimed:",
      stampTooltip: "Stamp {n}/10"
    },
    profile: {
      title: "My Profile & Bookings",
      subtitle: "Manage your appointments, check your loyalty card, and rebook instantly.",
      myBookings: "My Bookings",
      upcoming: "Upcoming",
      past: "Completed",
      noBookings: "You have no bookings yet.",
      bookFirstBtn: "Book First Appointment",
      logout: "Log Out",
      cancelBooking: "Cancel",
      rebook: "Rebook Service"
    },
    admin: {
      title: "Aura Hair Management Dashboard",
      badge: "Admin Access",
      subtitle: "Appointment management, status tracking, and revenue overview",
      refresh: "Refresh",
      totalRecords: "Total Bookings",
      activePending: "Active / Confirmed",
      completed: "Completed",
      estRevenue: "Estimated Revenue",
      allStatus: "All Statuses",
      searchPlaceholder: "Search client name, phone or code...",
      noResults: "No bookings found",
      markConfirmed: "Confirm",
      markCompleted: "Complete",
      markCancelled: "Cancel",
      delete: "Delete",
      whatsappCustomer: "WhatsApp Client",
      protectedTitle: "Protected Admin Access",
      enterPinPrompt: "Please enter the 6-digit security PIN for Aura Hair.",
      pinPlaceholder: "PIN Code (••••••)",
      pinErrorText: "Incorrect PIN code! Please try again.",
      loginBtn: "Log In",
      logoutBtn: "Log Out",
      thCode: "Booking / Code",
      thClient: "Client Details",
      thService: "Service",
      thDateTime: "Date & Time",
      thTotal: "Total",
      thStatus: "Status",
      thActions: "Actions",
      tabAppointments: "Appointments",
      tabCustomers: "Clients & Loyalty",
      tabReports: "Daily Reports & Cash",
      tabReset: "System Reset",
      registeredClients: "Registered Clients",
      rewardReadyBadge: "Reward Ready",
      searchCustomerPlaceholder: "Search client name, phone or email...",
      customersCount: "{n} Clients Registered",
      thCustomer: "Client",
      thContact: "Contact",
      thTotalVisits: "Total Visits",
      thStampCard: "Stamp Card (0-10)",
      thRewardStatus: "Discount Status",
      thTotalSpend: "Total Spend",
      thAdjustStamps: "Adjust Stamps",
      noCustomersFound: "No registered clients found.",
      visitsUnit: "Bookings",
      lastVisitLabel: "Last:",
      registeredLabel: "Registered:",
      rewardReadyText: "🎉 1 Free Haircut Ready!",
      remainingVisitsText: "{n} visits left",
      addStampTitle: "Add 1 Stamp",
      removeStampTitle: "Remove 1 Stamp",
      sendWhatsAppTitle: "Send WhatsApp Message",
      msgRewardReady: "Hello {name}, you have collected 10 loyalty stamps at Aura Hair Rotterdam! Your 1 free haircut is ready for your next booking. See you soon at Samuel Esmeijerplein 3!",
      msgStampProgress: "Hello {name}, your current loyalty card at Aura Hair Rotterdam: {stamps}/10 stamps. Only {remaining} booking(s) left until your free haircut!"
    },
    music: {
      title: "Aura Hair Lounge Music",
      nowPlaying: "Now Playing",
      paused: "Paused (Click to play)",
      volume: "Volume",
      openYoutube: "Watch on YouTube"
    },
    footer: {
      quickLinks: "Quick Links",
      popularServices: "Popular Services",
      onlineBooking: "Online Booking",
      bookFast: "Zero waiting time, book your seat online in 1 minute.",
      adminLogin: "Aura Hair Admin Login",
      allRights: "All rights reserved.",
      paymentMethods: "Accepted Payments: PIN, iDEAL, Apple Pay, Cash"
    }
  },

  tr: {
    nav: {
      services: "Hizmetler",
      hairpiece: "Protez Saç (Haarwerk)",
      products: "Ürünler",
      barbers: "Kuaförler",
      gallery: "Galeri",
      reviews: "Yorumlar",
      contact: "İletişim & Konum",
      adminPanel: "Kuaför Paneli",
      bookNow: "RANDEVU AL",
      openStatus: "Şu an Açık",
      closedStatus: "Şu an Kapalı",
      closingAt: "Kapanış 17:00",
      opensTomorrow: "Yarın 09:00'da Açık",
      closedDays: "Pazar & Pazartesi Kapalı",
      myAccount: "Hesabım",
      loginRegister: "Giriş Yap / Üye Ol",
      stampsLabel: "damga"
    },
    hero: {
      badge: "Kapsalon, Barbershop & Haarwerk Rotterdam",
      title1: "Kusursuz Saç &",
      title2: "Erkek Protez Saç Merkezi.",
      subtitle: "Rotterdam Samuel Esmeijerplein 3 adresinde modern saç kesimleri, skin fade, sakal tasarımı ve %100 gerçek insan saçından kişiye özel medikal protez saç uygulamaları.",
      bookAppointment: "Hemen Randevu Al",
      viewServices: "Hizmetleri ve Fiyatları Gör",
      sterileKits: "%100 Hijyenik & Steril Ekipman",
      noWaiting: "Randevulu Sıfır Bekleme",
      freeDrinks: "Ücretsiz İkram & Kahve Barı",
      idealAccepted: "PIN, iDEAL & Nakit Geçerli",
      experience: "Yıllık Deneyim",
      happyClients: "Mutlu Müşteri",
      googleRating: "Google Puanı",
      masterBarbers: "Usta Kuaför",
      salonLocation: "Samuel Esmeijerplein 3 • Rotterdam",
      salonTitle: "Aura Hair Hair & Grooming",
      googleReviewsText: "Google Yorumları",
      premiumTag: "Premium Kalite"
    },
    hairpiece: {
      badge: "Cerrahi Olmayan Saç Çözümü",
      mainTitle: "Erkekler İçin Protez Saç | Ameliyatsız Saç Dönüşümü",
      subGoldTitle: "%100 Gerçek İnsan Saçı & Kişiye Özel Ultra İnce PU Deri Altyapı",
      description: "Ameliyata ve acıya gerek olmadan, %100 doğal insan saçından üretilen mikro PU tabanlı protez saçlar. Kendi saçınızla kusursuz uyum sağlar, suya ve tere dayanıklıdır.",
      step1Badge: "1. ADIM: SAÇ DÖKÜLME AŞAMANIZI SEÇİN",
      step1Title: "Saç dökülme tipinizi belirleyin:",
      selectCard: "SEÇ",
      selectedCard: "SEÇİLDİ",
      recBadge: "Sizin İçin Önerilen Çözüm:",
      humanHairFeature: "%100 Gerçek İnsan Saçı",
      puBaseFeature: "Şeffaf, Nefes Alan Mikro Deri",
      bookFreeIntakeBtn: "ÜCRETSİZ ÖN GÖRÜŞME RANDEVUSU AL (€0)",
      sendPhotoWhatsApp: "WhatsApp ile Fotoğraf Gönder",
      galleryBadge: "SİZİN İÇİN NE YAPABİLİRİZ?",
      galleryTitle: "Erkekler İçin Saç Dönüşüm Örnekleri",
      gallerySub: "Aura Hair'te uygulanan %100 gerçek insan saçı ve sıfır geçişli kesim sonuçları.",
      trans1Title: "Tepe & Alın Hattı Restorasyonu",
      trans1Desc: "Seyrekleşen tepe ve alın çizgisi 90 dakikada %100 doğal görünüme kavuşturuldu.",
      trans2Title: "Modern Skin Fade & Doku Kesimi",
      trans2Desc: "Genç ve dinamik saç tasarımı ile 10 yaş gençleştiren doğal hacim.",
      trans3Title: "Hassas Makas Kesimi & Birleştirme",
      trans3Desc: "Mikro deri taban kafa derisiyle sıfırlanarak kendi saçınızla tamamen birleştirilir.",
      guarantee1Title: "%100 Gerçek İnsan Saçı",
      guarantee1Desc: "Doğal parlaklık, yumuşaklık ve hareket kabiliyeti. Asla yapay durmaz.",
      guarantee2Title: "0.03mm Ultra İnce Şeffaf Deri",
      guarantee2Desc: "Ön saç çizgisinde sıfır geçiş ve hava alan nefes alabilir mikro taban.",
      guarantee3Title: "Yüzme, Spor & Duş Özgürlüğü",
      guarantee3Desc: "Suya, tere ve şampuana tam dayanıklı medikal sabitleme.",
      guarantee4Title: "%100 Doğal & Fark Edilmez",
      guarantee4Desc: "En yakından bakıldığında dahi kafa derinizden kendi saçınız çıkıyormuş hissi verir."
    },
    services: {
      tag: "Hizmetlerimiz & Fiyat Listesi",
      title1: "Tüm Saç & Bakım",
      title2: "Hizmetlerimiz",
      subtitle: "Skin Fade kesimden sıcak havlu sakal tıraşına, protez saç bakımından VIP grooming ritüeline kadar geniş menü.",
      all: "Tüm Hizmetler",
      hair: "Saç & Şekillendirme",
      beard: "Sakal & Tıraş",
      care: "Bakım & Spa",
      vip: "Özel Paketler",
      hairpieceCat: "Protez Saç",
      minutes: "dk",
      includes: "Dahil Olanlar:",
      addToBooking: "Seç & Randevu Al",
      popularTag: "En Çok Tercih Edilen",
      trendTag: "Trend",
      ritualTag: "Geleneksel Ritüel",
      specialCareTag: "Özel Bakım",
      vipTag: "VIP Deneyim",
      freeText: "Ücretsiz"
    },
    gallery: {
      tag: "Portfolyo & İlham",
      title1: "Stil & Kesim",
      title2: "Galerisi",
      subtitle: "Aura Hair'te yapılan en yeni saç kesimleri, skin fade geçişleri ve sakal tasarımları.",
      all: "Tüm Modeller",
      fade: "Fade & Geçişler",
      classic: "Klasik & Makas",
      beard: "Sakal Tasarımı",
      hairpiece: "Protez Saç",
      viewBtn: "Fotoğrafı İncele",
      close: "Kapat",
      barberLabel: "Kuaför"
    },
    reviews: {
      tag: "Müşteri Yorumları",
      title1: "Değerli Müşterilerimizin",
      title2: "Görüşleri",
      subtitle: "Rotterdam'daki salonumuzdan 5 yıldızla ayrılan gerçek misafir deneyimleri.",
      verifiedCustomer: "Doğrulanmış Müşteri"
    },
    contact: {
      tag: "İletişim & Konum Bilgileri",
      title1: "Salonumuza",
      title2: "Ulaşım & Rezervasyon",
      subtitle: "Samuel Esmeijerplein 3, 3067 HP Rotterdam adresinde hizmetinizdeyiz. Toplu taşıma ve otopark imkanı mevcuttur.",
      phoneTitle: "Telefonla İletişim",
      whatsappTitle: "WhatsApp Randevu & Danışma",
      addressTitle: "Açık Adres",
      workingHoursTitle: "Çalışma Saatleri",
      callNow: "Hemen Ara",
      whatsappChat: "WhatsApp'tan Yaz",
      openInGoogleMaps: "Haritada Aç",
      getDirections: "Canlı Yol Tarifi",
      paymentMethodsTitle: "Geçerli Ödeme Yöntemleri",
      open7Days: "Salı - Cumartesi Açık (09:00 - 17:00)",
      walkInNote: "Randevusuz misafirlerimiz uygunluk durumuna göre ağırlanmaktadır.",
      ctaTitle: "Tarzınızı Yenilemeye Hazır mısınız?",
      ctaSubtitle: "1 dakikadan kısa sürede Aura Hair'te yerinizi ayırtın.",
      directNav: "Canlı Yol Tarifi",
      rotterdamDistrict: "3067 HP Rotterdam (Prins Alexander / Het Lage Land)",
      copyAddress: "Adresi Kopyala",
      copied: "Kopyalandı!",
      openInApp: "Harita Uygulamasında Aç",
      closedText: "Kapalı"
    },
    booking: {
      title: "Online Randevu Sistemi",
      subtitle: "İstediğiniz hizmeti, uygun gün ve saati kolayca seçin.",
      step1: "1. Hizmet Seçimi",
      step2: "2. Gün & Saat",
      step3: "3. Müşteri Bilgileri",
      step4: "4. Randevu Onayı",
      servicesHeading: "Bir veya Birden Fazla Hizmet Seçin",
      servicesSub: "Saç kesimi, sakal tasarımı ve bakım işlemlerini birleştirebilirsiniz.",
      dateHeading: "Randevu Gününü Seçin",
      timeHeading: "Randevu Saatini Seçin",
      hoursNotice: "Salı - Cts: 09:00 - 17:00 (Paz & Pzt Kapalı)",
      contactHeading: "İletişim Bilgileriniz",
      contactSub: "Randevu teyidinizin iletilmesi için bilgilerinizi giriniz.",
      fullName: "Adınız Soyadınız",
      fullNamePlaceholder: "Örn: Daan van Dijk",
      phone: "Telefon Numaranız",
      phonePlaceholder: "Örn: +31 6 12 34 56 78",
      email: "E-Posta Adresiniz (İsteğe Bağlı)",
      emailPlaceholder: "Örn: daan@example.com",
      notes: "Özel İstek / Notunuz (İsteğe Bağlı)",
      notesPlaceholder: "Örn: Sıfırlama yüksek olsun, sakal yağı kullanılsın...",
      summaryServices: "hizmet seçildi",
      totalPrice: "Toplam:",
      next: "İleri",
      back: "Geri",
      confirmBooking: "Randevuyu Onayla",
      successTitle: "Randevunuz Başarıyla Oluşturuldu!",
      successSub: "Sizi Rotterdam Samuel Esmeijerplein 3 adresindeki salonumuzda ağırlamaktan mutluluk duyacağız.",
      bookingCode: "Randevu Kodu",
      status: "Durum",
      confirmedStatus: "Onaylandı",
      client: "Müşteri:",
      masterBarber: "Salon:",
      dateTime: "Tarih & Saat:",
      estDuration: "Tahmini Süre:",
      selectedServices: "Seçilen Hizmetler:",
      whatsappNotify: "WhatsApp ile Bildir",
      close: "Kapat",
      today: "Bugün",
      tomorrow: "Yarın",
      nameRequired: "Lütfen adınızı ve soyadınızı giriniz.",
      phoneRequired: "Lütfen geçerli bir telefon numarası giriniz.",
      loyaltyDiscountPill: "🎁 10. Randevu Sadakat Hediyesi: 1 Adet Bedava Saç Kesimi!",
      specialDiscountPill: "🎉 Özel Günler İndirimi Aktif!",
      applySpecialDiscount: "İndirimi Uygula",
      specialDayActive: "Özel Gün Kampanyası:",
      regularPrice: "Normal Tutar:",
      discountedPrice: "VIP Üye Tutarı:"
    },
    auth: {
      loginTab: "Giriş Yap",
      registerTab: "Üye Ol",
      loginTitle: "Tekrar Hoş Geldiniz",
      loginSub: "Randevularınızı ve sadakat kartınızı yönetmek için giriş yapın.",
      registerTitle: "Yeni Hesap Oluştur",
      registerSub: "Sadece kayıtlı müşterilere özel: Her 10 randevunuzda 1 bedava saç kesimi kazanın!",
      identifierLabel: "Telefon Numarası veya E-posta",
      identifierPlaceholder: "+31 6 ... veya ad@email.com",
      nameLabel: "Adınız Soyadınız",
      namePlaceholder: "Örn: Daan van Dijk",
      phoneLabel: "Telefon Numaranız",
      phonePlaceholder: "+31 6 12 34 56 78",
      emailLabel: "E-Posta Adresiniz (İsteğe Bağlı)",
      emailPlaceholder: "daan@example.com",
      passwordLabel: "Şifre / PIN Kodu",
      passwordPlaceholder: "Şifrenizi veya 4 haneli PIN kodunuzu girin",
      loginBtn: "Giriş Yap",
      registerBtn: "Hesap Oluştur & Kaydet",
      noAccount: "Hesabınız yok mu?",
      haveAccount: "Zaten hesabınız var mı?",
      loginSuccess: "Giriş başarılı!",
      registerSuccess: "Hesabınız başarıyla oluşturuldu!",
      userNotFound: "Bu bilgilere ait bir kullanıcı bulunamadı.",
      wrongPassword: "Şifreniz hatalı.",
      alreadyExists: "Bu telefon veya e-posta ile kayıtlı bir hesap zaten var.",
      orSocial: "Veya şununla devam edin",
      googleBtn: "Google / Google Play",
      facebookBtn: "Facebook",
      socialConnecting: "Bağlanıyor...",
      socialSuccess: "Başarıyla bağlandı!"
    },
    loyalty: {
      cardTitle: "Aura Hair Dijital Sadakat Kartı",
      cardSub: "10 damga toplayın, 1 adet bedava saç kesimi kazanın!",
      stampsProgress: "Toplanan Damgalar",
      remainingText: "Bedava saç kesiminiz için son {n} randevu!",
      eligibleText: "🎉 Tebrikler! Bir sonraki randevunuz 10. randevunuz olup 1 adet BEDAVA saç kesimi kazandınız!",
      totalVisits: "Toplam Ziyaret:",
      rewardsClaimed: "Kazanılan Bedava Kesim:",
      stampTooltip: "Damga {n}/10"
    },
    profile: {
      title: "Profilim & Randevularım",
      subtitle: "Geçmiş ve aktif randevularınızı takip edin, tek tıkla yeniden randevu alın.",
      myBookings: "Randevularım",
      upcoming: "Yaklaşan",
      past: "Tamamlanan",
      noBookings: "Henüz bir randevunuz bulunmuyor.",
      bookFirstBtn: "İlk Randevuyu Al",
      logout: "Çıkış Yap",
      cancelBooking: "İptal Et",
      rebook: "Tekrar Randevu Al"
    },
    admin: {
      title: "Aura Hair Kuaför Yönetim Paneli",
      badge: "Yönetici Girişi",
      subtitle: "Randevu takibi, durum güncelleme ve ciro raporları",
      refresh: "Yenile",
      totalRecords: "Toplam Randevu",
      activePending: "Aktif / Onaylı",
      completed: "Tamamlanan",
      estRevenue: "Tahmini Ciro",
      allStatus: "Tüm Durumlar",
      searchPlaceholder: "Müşteri adı, telefon veya kod ile ara...",
      noResults: "Randevu bulunamadı",
      markConfirmed: "Onayla",
      markCompleted: "Tamamla",
      markCancelled: "İptal Et",
      delete: "Sil",
      whatsappCustomer: "Müşteriye WhatsApp Gönder",
      protectedTitle: "Kuaför Yönetici Girişi",
      enterPinPrompt: "Lütfen 6 haneli kuaför güvenlik şifresini giriniz.",
      pinPlaceholder: "PIN Kodu (••••••)",
      pinErrorText: "Hatalı şifre! Lütfen tekrar deneyin.",
      loginBtn: "Giriş Yap",
      logoutBtn: "Çıkış Yap",
      thCode: "Randevu Kodu",
      thClient: "Müşteri Bilgileri",
      thService: "Hizmet",
      thDateTime: "Tarih & Saat",
      thTotal: "Tutar",
      thStatus: "Durum",
      thActions: "İşlemler",
      tabAppointments: "Randevular",
      tabCustomers: "Müşteriler & Sadakat",
      tabReports: "Gün Sonu & Raporlar",
      tabReset: "Sistem Sıfırlama",
      registeredClients: "Kayıtlı Müşteriler",
      rewardReadyBadge: "İndirimli",
      searchCustomerPlaceholder: "Müşteri adı, telefon veya e-posta ile ara...",
      customersCount: "{n} Müşteri Kayıtlı",
      thCustomer: "Müşteri",
      thContact: "İletişim",
      thTotalVisits: "Toplam Ziyaret",
      thStampCard: "Damga Kartı (0-10)",
      thRewardStatus: "Hediye Durumu",
      thTotalSpend: "Toplam Ciro",
      thAdjustStamps: "Damga Ayarla",
      noCustomersFound: "Henüz kayıtlı üye bulunamadı.",
      visitsUnit: "Randevu",
      lastVisitLabel: "Son:",
      registeredLabel: "Kayıt:",
      rewardReadyText: "🎉 1 Bedava Saç Kesimi Hazır!",
      remainingVisitsText: "son {n} randevu",
      addStampTitle: "1 Damga Ekle",
      removeStampTitle: "1 Damga Azalt",
      sendWhatsAppTitle: "WhatsApp Mesajı Gönder",
      msgRewardReady: "Merhaba {name}, Aura Hair Rotterdam'da 10. randevu sadakat damganızı tamamladınız! Sıradaki randevunuzda 1 adet bedava saç kesiminiz hazır. Bekliyoruz!",
      msgStampProgress: "Merhaba {name}, Aura Hair Rotterdam'daki güncel sadakat damganız: {stamps}/10. Bedava saç kesimi için son {remaining} randevu!"
    },
    music: {
      title: "Aura Hair Dinlendirici Müzik",
      nowPlaying: "Şu An Çalıyor",
      paused: "Duraklatıldı (Başlatmak için tıkla)",
      volume: "Ses Düzeyi",
      openYoutube: "YouTube'da Aç"
    },
    footer: {
      quickLinks: "Hızlı Menü",
      popularServices: "Popüler Hizmetler",
      onlineBooking: "Online Randevu",
      bookFast: "Bekleme yok, 1 dakikada online yerinizi ayırtın.",
      adminLogin: "Kuaför Yönetici Girişi",
      allRights: "Tüm hakları saklıdır.",
      paymentMethods: "Geçerli Ödeme Yöntemleri: PIN, iDEAL, Apple Pay, Nakit"
    }
  }
};
